import { createMutation } from '../store';
import { validateEmailMXRecords } from './requests';

export const useValidateEmailMXRecords = createMutation({
  request: (email: string) => validateEmailMXRecords({ email })
});
